export const utilFormatTime = (secs: number) => {
  const m = Math.floor(secs / 60).toString();
  const s = (secs % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
};
